import Luxury from './Luxury';

export default Luxury;